fetch('https://ipapi.co/json/?key=1z3zSS7I2w9nk3WzVsWcEwGyDxgLtWYD4Iw67JNYkkMzPhekdP')
.then(function(response) {
  response.json().then(jsonData => {
    //console.log(jsonData);
    localStorage.setItem('customer_location', JSON.stringify(jsonData))
    sessionStorage.setItem('customer_location_ca', JSON.stringify(jsonData))

    if(jsonData['country_code'] === 'US') {
      document.body.classList.add('country-us');
    } else {
      document.body.classList.add('country-intl');
    }

    if(jsonData['country_code'] == 'US' && (jsonData['region_code'] == 'AK' || jsonData['region_code'] == 'HI')) {
      const fsbPlaceholder = document.querySelector('#fsb_placeholder');
      if(fsbPlaceholder) {
        fsbPlaceholder.style.display = 'none';
        setTimeout(() => {
          document.querySelector('#custom_shipping_placeholder').style.display = 'block';
        }, 0);
      } 
    }

    if (jsonData['country_code'] === 'CA') {
      const banner = document.querySelector('#canada-banner');
      if (banner) {
        banner.style.display = 'block';
      }
    }

    if (jsonData['country_code'] === 'CA' && !sessionStorage.getItem('canada-popup-shown')) {
      const popup = document.querySelector('.canada-popup');
      const body = document.querySelector('body');
      if (popup) {
        popup.style.display = 'flex';
        body.style.overflow = 'hidden';
      }
      sessionStorage.setItem('canada-popup-shown', 'true');
    }

  });
})
.catch(function(error) {
  console.log(error)
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.action-area__link__account').forEach((link__account) => {
    link__account.addEventListener('click',(e) => {
      e.preventDefault();
      link__account.nextElementSibling.classList.toggle('is-open');
    });
  })
});
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

const customerCountry = () => {
  return new Promise((resolve, reject) => {
    const customerData = false;//JSON.parse(localStorage.getItem('customer_location'));
    if(customerData && customerData.hasOwnProperty('country') && customerData.country) {
      resolve(customerData.country.toUpperCase());
    } else {
      /*
      fetch('https://ipapi.co/json/')
          .then((response) => response.json())
          .then(jsonData => {
            resolve(jsonData.country.toUpperCase());
          })
          .catch(function(error) {
            resolve('US');
          });
       */
      fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json' + '?country[enabled]=true')
          .then(r => r.json())
          .then(jsonData => {
            if(jsonData &&
                jsonData.hasOwnProperty('detected_values') &&
                jsonData.detected_values &&
                jsonData.detected_values.hasOwnProperty('country') &&
                jsonData.detected_values.country &&
                jsonData.detected_values.country.hasOwnProperty('handle') &&
                jsonData.detected_values.country.handle
            ) {
              const customer_location = {
                country: jsonData.detected_values.country.handle,
                country_code: jsonData.detected_values.country.handle
              };
              localStorage.setItem('customer_location', JSON.stringify(customer_location))
              const countryCode = customer_location.country.toUpperCase();
              if(countryCode === 'US') {
                document.body.classList.add('country-us');
              } else {
                document.body.classList.add('country-intl');
              }
              resolve(countryCode);
            }
          })
          .catch(function(error) {
            resolve('US');
          });
    }
  })
};

const updateVariantsByLocations = (variants) => {
  return customerCountry().then((country) => {
    country = country === 'CA' ? country : 'US';
    console.log('country',country);
    variants.forEach((variant) => {
      // No per-location inventory metafield (e.g. Simple Bundles variants): keep Shopify's native availability
      if(!Array.isArray(variant.inventory) || variant.inventory.length === 0) return;
      if(variant.inventory_management !== 'false') {
        let variantFound = false;
        variant.available = false;
        variant.inventory.forEach((inv) => {
          if(window.evanhealy_settings.locations[inv['location_id']] === country) {
            variantFound = true;
            if(inv['available'] > 0) {
              variant.available = true;
            }
          }
        })
        if(!variantFound) {
          variant.found = false;
        }
      }
    })
  })
};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary:not([bound])').forEach(summary => {
      summary.addEventListener('click', this.onSummaryClick.bind(this))
      summary.setAttribute('bound','')
    });
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      if (!details.hasAttribute('data-prevent-close')) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    let isClear = false;
    if (event.target && event.target.classList.contains('active-facets__button-remove--tags')) {
      isClear = true
    }
    if (event.relatedTarget && event.relatedTarget.classList.contains('active-facets__button-remove--tags')) {
      isClear = true
    }
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement) && !isClear) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    /*
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
     */
    detailsElement.removeAttribute('open');
    if (detailsElement.closest('details[open]')) {
      trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    this.loadContent();
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onLoad = true;
    this.addEventListener('change', this.onVariantChange);
    this.getVariantData();
    if (document.querySelector('.product__info-container .bundle-selects')) {
      setTimeout(function() {
        const event = new Event('change');
        document.querySelector('.product__info-container .bundle-selects').dispatchEvent(event);
      }, 500)
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantSelects();
      this.updateKlaviyoBtn();
      this.updateShade();
    }

    this.onLoad = false;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    if(this.onLoad) return;
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    if(this.onLoad) return;
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const idClone = `price-clone-${this.dataset.section}`;
        const idMobile = `price-mobile-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const destinationClone = document.getElementById(idClone);
        const destinationMobile = document.getElementById(idMobile);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationClone) destinationClone.innerHTML = source.innerHTML;
        if (source && destinationMobile) destinationMobile.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        var moneyElements = document.querySelectorAll('span.money');

        if ( moneyElements ) {
          Array.prototype.forEach.call(moneyElements, function (moneyEle) {
            Shopify.theme.currencyConverter.update(moneyEle);
          });
        }

        if (price) price.classList.remove('visibility-hidden');
      });
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  updateKlaviyoBtn() {
    const event = new CustomEvent("ehUpdateKlaviyoBtn", {detail: {'variant':this.currentVariant}});
    const productEvent = new CustomEvent(`ehUpdateKlaviyoBtn${this.currentVariant.product_id}`, {detail: {'variant':this.currentVariant}});
    window.dispatchEvent(event);
    window.dispatchEvent(productEvent);
  }

  updateShade() {
    if (typeof shadeShortDescriptions !== 'undefined') {
      const shadeLabelEl = document.querySelector('.shade-label');
      let shadeLabel = ''
      for (let option of this.currentVariant.options) {
        if (option.toLowerCase().includes('shade')) {
          shadeLabel = option;
          break;
        }
      }
  
      for (let shadeDesc of shadeShortDescriptions) {
        let shadeDescLabel = 'Shade ' + shadeDesc.split(':')[0];
        if (shadeLabel == shadeDescLabel) {
          shadeLabel = '<strong>'+ shadeDescLabel + '</strong>' + ' — ' + shadeDesc.split(':')[1];
          break;
        }
      }
      
      if (shadeLabelEl) {
        shadeLabelEl.innerHTML = shadeLabel;
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    //if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    let variants = JSON.parse(document.querySelector(`[data-product-variants="${this.dataset.section}"]`).textContent);
    let priceVaries = document.querySelector(`[data-product-variants="${this.dataset.section}"]`)?.dataset?.priceVaries;
    updateVariantsByLocations(variants).then(() => {
      this.variantData = variants;
      let isFound = variants.filter(v => v.found === true);
      variants.forEach((variant) => {
        if(!variant.found) {
          document.querySelectorAll(`input[value="${variant.options[0]}"]`).forEach((el) => {
            el.classList.add('not-found');
          })
        }
      });
      if(isFound.length === 0) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else if (priceVaries === "true" || isFound.length === 1){
        this.querySelector(`input[value="${isFound[0].options[0]}"]`).click();
      }
    });
  }

  updateVariantSelects() {
    if (!this.currentVariant) return;
    const selects = document.querySelectorAll('.product-form__input .select__select');
    let optionsList = [];
    selects.forEach((select) => {
      optionsList.push(select.value)
    });
    const equals = (a, b) => JSON.stringify(a) === JSON.stringify(b);
    selects.forEach((select, index) => {
      const options = select.querySelectorAll('option');
      const variantIndex = `option${index+1}`;

      options.forEach((option) => {
        let dumpList = [...optionsList];
        dumpList[index] = option.value;
        this.variantData.forEach((variant) => {
          if (equals(variant.options, dumpList)) {
            if (variant.available) {
              option.innerHTML = option.value;
              option.dataset.available = true;
            } else {
              option.innerHTML = `${option.value} (out of stock)`;
              option.dataset.available = false;
            }
          }
        });
      });
      let sortedOptions = [];
      options.forEach((option) => {
        sortedOptions.push(option);
      });
      const isAvailable = (option) => option.dataset.available == true || option.dataset.available == 'true';
      sortedOptions = sortedOptions.sort((a, b) => isAvailable(b) - isAvailable(a));
      select.innerHTML = '';
      sortedOptions.forEach((option) => {
        select.appendChild(option)
      });
    });
    const priceRange = document.querySelector('.price-range');
    const priceVaries = document.querySelector('.price--varies');
    if (priceRange) {
      priceRange.style.display = 'none';
    }
    if (priceVaries) {
      priceVaries.classList.remove('price--varies');
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class BestsellerTabs extends HTMLElement {
  constructor() {
    super();
    this.swipers = [];
    this.labels = this.querySelectorAll('label');
    this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('click', this.onChange.bind(this)));

    this.dropdownParent = this.querySelector('.bestseller-links-dropdown');
    if(this.dropdownParent) {
      this.dropdown = this.dropdownParent.querySelector('strong');
      this.dropdown.addEventListener('click', this.toggleDropdown.bind(this));
    }

    this.breakpoint = window.matchMedia('(max-width:767px)');
    this.breakpoint.addListener(this.breakpointCheck.bind(this));
    this.breakpointCheck();
  }

  toggleDropdown(event) {
    this.dropdownParent.classList.toggle('open');
  }

  onChange(event) {
    this.labels.forEach(label => label.classList.remove('active'));
    const activeLabel = this.querySelector('label[for="'+event.target.id+'"]');
    const activeTabName = activeLabel.textContent;
    activeLabel.classList.add('active');
    if(this.dropdownParent) {
      this.dropdownParent.classList.remove('open');
      this.dropdown.textContent = activeTabName;
    }
  }

  breakpointCheck() {
    if (this.breakpoint && this.breakpoint.matches === true ) {
      // mobile
      if(this.swipers.length === 0) {
        this.querySelectorAll('.bestseller-grid').forEach((bestsellers) => {
          const totalSlides = bestsellers.querySelectorAll('.bestseller-item');
          if(totalSlides.length > 2) {
            const sectionId = bestsellers.dataset.sectionId;
            const swiper = new Swiper(bestsellers, {
              slidesPerView: 2,
              spaceBetween: 8,
              slidesPerGroup: 2,
              navigation: {
                nextEl: '.button-next-'+sectionId,
                prevEl: '.button-prev-'+sectionId,
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              },
              createElements: true,
            });
            this.swipers.push(swiper);
          }
        });
      }

    } else if (this.breakpoint.matches === false) {
      // desktop
      if(this.swipers.length > 0) {
        this.swipers.forEach((swiper) => {
          const wrapper = swiper.wrapperEl;
          swiper.destroy(true, true);
          wrapper.replaceWith(...wrapper.childNodes)
        });
        this.swipers = [];
      }
    }
  }
}

customElements.define('bestseller-tabs', BestsellerTabs);

class LogosSwiper extends HTMLElement {
  constructor() {
    super();
    this.swipers = [];
    this.breakpoint = window.matchMedia('(max-width:767px)');
    this.breakpoint.addListener(this.breakpointCheck.bind(this));
    this.breakpointCheck();
  }

  breakpointCheck() {
    if (this.breakpoint && this.breakpoint.matches === true ) {
      // mobile
      if(this.swipers.length === 0) {
        this.querySelectorAll('.swiper').forEach((el) => {
          const sectionId = el.dataset.sectionId;
          const mobileSlides = parseInt(el.dataset.slidesMobile);
          const swiper = new Swiper(el, {
            slidesPerView: mobileSlides,
            spaceBetween: 8,
            slidesPerGroup: mobileSlides,
            navigation: {
              nextEl: '.button-next-'+sectionId,
              prevEl: '.button-prev-'+sectionId,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            createElements: true,
          });
          this.swipers.push(swiper);
        });
      }

    } else if (this.breakpoint.matches === false) {
      // desktop
      if(this.swipers.length > 0) {
        this.swipers.forEach((swiper) => {
          const wrapper = swiper.wrapperEl;
          swiper.destroy(true, true);
          wrapper.replaceWith(...wrapper.childNodes)
        });
        this.swipers = [];
      }
    }
  }
}

customElements.define('logos-swiper', LogosSwiper);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.footerMode = null;
    this.parentDiv = this.querySelector('.footer__blocks-wrapper');
    this.footerGrid = {
      'mobile': [
        ['shop','community','education'],['about-us','skin-guide','questions'],
      ],
      'desktop': [
        ['shop'],['about-us','community'],['skin-guide','education'],['questions']
      ]
    };
    this.footerClasses = 'footer-block grid__item footer-block--menu';
    this.breakpoint = window.matchMedia('(min-width:750px)');
    this.breakpoint.addListener(this.breakpointCheck.bind(this));
    this.breakpointCheck();

  }

  mobileFooter() {
    if(this.footerMode !== 'mobile') {
      this.footerMode = 'mobile';
      this.generateFooterMenu(this.footerGrid['mobile']);
    }
  }

  desktopFooter() {
    if(this.footerMode !== 'desktop') {
      this.footerMode = 'desktop';
      this.generateFooterMenu(this.footerGrid['desktop']);
    }
  }

  generateFooterMenu(columns) {
    let wrapper = document.createElement('div');
    columns.forEach((col) => {
      let colDiv = document.createElement('div');
      colDiv.className = this.footerClasses;
      col.forEach((menu) => {
        colDiv.appendChild(this.querySelector(`[data-menu="${menu}"]`));
      });
      wrapper.appendChild(colDiv);
    });
    this.parentDiv.innerHTML = wrapper.innerHTML;
  }

  breakpointCheck() {
    if (this.breakpoint && this.breakpoint.matches === true ) {
      this.desktopFooter();
    } else if (this.breakpoint.matches === false) {
      this.mobileFooter();
    }
  }
}

customElements.define('footer-component', FooterComponent);

class VideoContainer extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type;
    this.id = this.dataset.videoId;
    this.image = this.querySelector('img');
    let iframe = document.createElement('iframe');
    iframe.title = 'video';
    iframe.setAttribute('allowfullscreen','');
    iframe.setAttribute('allow','autoplay; encrypted-media');
    iframe.addEventListener('load', this.onLoad.bind(this));
    let src = '';
    if(this.type === 'vimeo') {
      src = `https://player.vimeo.com/video/${this.id}?autoplay=1&amp;loop=1&amp;muted=1&amp;controls=0`;
    } else {
      src = `https://www.youtube.com/embed/${this.id}?enablejsapi=1`;
    }
    iframe.src = src;
    this.appendChild(iframe);
  }
  onLoad() {
    //this.image.remove();
  }
}

customElements.define('video-container', VideoContainer);
document.addEventListener('DOMContentLoaded', function () {
  let postsCarouselSwipers = [];
  const $postsCarouselSwipers = document.querySelectorAll('.posts-carousel:not(.swiper-initialized)');
  if($postsCarouselSwipers && $postsCarouselSwipers.length > 0) {
    $postsCarouselSwipers.forEach(($postsCarouselSwiper) => {
      const sectionId = $postsCarouselSwiper.dataset.sectionId;
      const postsCarouselSwiper = new Swiper($postsCarouselSwiper, {
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1,
        navigation: {
          nextEl: '.button-next-'+sectionId,
          prevEl: '.button-prev-'+sectionId,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          749: {
            slidesPerView: 2,
            pagination: false
          }
        }
      });
      postsCarouselSwipers.push(postsCarouselSwiper);
    });
  }


  let pinsSwipers = [];
  const $pinsSwipers = document.querySelectorAll('.pins-swiper:not(.swiper-initialized)');
  if($pinsSwipers && $pinsSwipers.length > 0) {
    $pinsSwipers.forEach(($pinsSwiper) => {
      const sectionId = $pinsSwiper.dataset.sectionId;
      const pinsSwiper = new Swiper($pinsSwiper, {
        loop: true,
        pagination: {
          el: ".swiper-pins-pagination",
        },
        breakpoints: {
          768: {
            pagination: false,
            navigation: {
              nextEl: '.swiper-pins-button-next',
              prevEl: '.swiper-pins-button-prev',
            }
          }
        },
        on: {
          slideChange: function () {
            var pinIcon = document.getElementsByClassName('pin-icon');
          
            for (var i = 0; i < pinIcon.length; i++) {
              pinIcon[i].classList.remove('pin-icon__show');
              pinIcon[i].style.animation = 'none';
            }

            var index = this.activeIndex - 1;
            var size = this.slides.length - 2;

            if(this.activeIndex < 1){
              var el = document.getElementsByClassName("pin-icon")[size - 1];
              el.classList.add("pin-icon__show");
            }
            else if(this.activeIndex == size + 1){
              var el = document.getElementsByClassName("pin-icon")[0];
              el.classList.add("pin-icon__show");
            }
            else{
              var el = document.getElementsByClassName("pin-icon")[index];
              el.classList.add("pin-icon__show");
            }

            var pinIcon = document.getElementsByClassName('pin-icon');
            setTimeout(() => {
              for (var i = 0; i < pinIcon.length; i++) {
                if (!pinIcon[i].classList.contains("pin-icon__show")) {
                  pinIcon[i].style.animation = 'pulse-animation 2s infinite';
                }
              }
            }, 1000);
          },
        }
      });
      pinsSwipers.push(pinsSwiper);
    });
  }
});

function pinSlideTo(idx){
  var pinIdx = parseInt(idx);
  const swiperPin = document.querySelector('.pins-swiper').swiper;
  swiperPin.slideTo(pinIdx);
}

function changePinBox(id, idx){
  var pinIdx = parseInt(idx);
  const swiperPin = document.querySelector('.pins-swiper').swiper;
  swiperPin.slideTo(pinIdx);
  // var pinIcon = document.getElementsByClassName('pin-icon');

  // for (var i = 0; i < pinIcon.length; i++) {
  //   pinIcon[i].classList.remove('pin-icon__show');
  //   pinIcon[i].style.animation = 'none';
  // }

  // document.getElementById('pin-'+ id).classList.add('pin-icon__show');



  // setTimeout(() => {
  //   for (var i = 0; i < pinIcon.length; i++) {
  //     if (!pinIcon[i].classList.contains("pin-icon__show")) {
  //       pinIcon[i].style.animation = 'pulse-animation 2s infinite';
  //     }
  //   }
  // }, 1000);
}

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}
